import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import { useToast } from "components/Toast";
import { sendCode, resetPassword } from 'api';

function Cover() {
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [countdown, setCountdown] = useState(0);
  const showToast = useToast();

  const handleSendCode = async () => {
    try {
      const res = await sendCode({ email });
      if (res.status !== 0) {
        showToast(res.msg, 'error');
        return;
      }
      setCountdown(60); // 设置冷却时间为60秒
      showToast("验证码已发送", 'success');
    } catch (error) {
      showToast("发送验证码失败，请重试", 'error');
    }
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const handleSubmit = async (event) => {
    event.preventDefault(); // 阻止表单的默认提交行为
    try {
      const res = await resetPassword({
        tel: email,
        v_code: verificationCode,
        password: newPassword
      });
      if (res.status !== 0) {
        showToast(res.msg, 'error');
        return;
      }
      showToast("密码重置成功", 'success');
    } catch (error) {
      showToast("重置密码失败，请重试", 'error');
    }
  };

  return (
    <BasicLayout image={bgImage} style={{ backgroundSize: 'cover' }}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            找回密码
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="新密码"
                variant="standard"
                fullWidth
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </MDBox>
            <MDBox mb={2} style={{ display: "flex" }}>
              <MDInput
                type="text"
                label="验证码"
                variant="standard"
                fullWidth
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
              />
              <MDButton
                variant="gradient"
                color="info"
                onClick={handleSendCode}
                disabled={countdown > 0}
                style={{ marginLeft: '10px', width: "180px" }}
              >
                {countdown > 0 ? `${countdown}s` : '发送验证码'}
              </MDButton>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="info" fullWidth>
                提交
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  前往登录
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Cover;
